export var SIGN_UP_URL = "/user/signup";